<template>
    <div>
     <div class="container">
        <div class="row contenedor-videos">
            <div class="col-12 contenedor-video">
                <video class="video" :src="rutaDeVideo" controls>
                <p>Su navegador no soporta vídeos HTML5.</p>
                </video>

            </div>
            <!-- <div class="col-4 contenedor-lista-videos">
                sssssssssssssssssssss
            </div> -->

        </div>

      </div>
    </div>
</template>

<script>


export default({
    data(){
        return{
            rutaDeVideo:String

        }
    },
    methods:{
        mostrarVideo:function(){
            console.log(this.$route.query)
            this.rutaDeVideo=atob(this.$route.query.ver);
            console.log( this.rutaDeVideo)

        }

    },
    mounted(){
       
        this.mostrarVideo();
      

    }
})
</script>

<style scoped>
.contenedor-visor{
    background-color: #6C7476;
}
.contenedor-video{
    background-color: 6C7476;
    
}
.contenedor-lista-videos{
    background-color: blue;
}
.contenedor-videos{
    margin-top: 5em;
}
.video{
    width: inherit;
    margin-top: 2em;
    margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaPrincipal/VisorVideos.vue